<template>
  <section class="features-tiles section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container">
      <div class="features-tiles-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item reveal-fade" data-reveal-delay="200">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="mb-16">
                  <font-awesome-icon class="fa-4x text-color-secondary" :icon="['fas', 'power-off']" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">
                  Control Power
                </h4>
                <p class="m-0 text-sm">
                  Easily start, stop, restart, or kill any of your servers at any time while on the go via Discord.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-fade" data-reveal-delay="400">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="mb-16">
                  <font-awesome-icon class="fa-4x text-color-secondary" :icon="['fas', 'terminal']" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">
                  Send Commands
                </h4>
                <p class="m-0 text-sm">
                  Send a quick command to your servers without having to open your panel or leave the conversation.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-fade" data-reveal-delay="600">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="mb-16">
                  <font-awesome-icon class="fa-4x text-color-secondary" :icon="['fas', 'info']" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">
                  View Status
                </h4>
                <p class="m-0 text-sm">
                  View the status of all your servers quickly and easily in a modern looking format.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js';
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue';

export default {
  name: 'CFeaturesTiles',
  components: {
    CSectionHeader
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: '',
        paragraph: ''
      }
    };
  }
};
</script>
